import { render } from "./SignaturePad.vue?vue&type=template&id=af9f146c&scoped=true"
import script from "./SignaturePad.vue?vue&type=script&lang=js"
export * from "./SignaturePad.vue?vue&type=script&lang=js"

import "./SignaturePad.vue?vue&type=style&index=0&id=af9f146c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-af9f146c"

export default script